<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <SeleccionEmisor></SeleccionEmisor>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import SeleccionEmisor from '../components/SeleccionEmisor.vue';
export default {
    name: 'SetEmitDataView',
    components: {
        ColumnaIzquierda,
        SeleccionEmisor,
    }
}
</script>